import style from "./PathProgressBanner.module.css";
import { useTranslation } from "react-i18next";

import PathProgressBar from "../pathProgressBar/PathProgressBar";
import PathScheduleAppointment from "../pathScheduleAppointment/PathScheduleAppointment";
import PathCoursesProgressHolder from "../pathCoursesProgressHolder/PathCoursesProgressHolder";

import { useGetMostLikedCourses } from "@/features/courses/hooks/useGetMostLikedCourses";

function PathProgressBanner() {
	const { t } = useTranslation();
	const { data: courses, isPending, isError } = useGetMostLikedCourses();

	if (isPending) return <div>{t("paths:progressBanner.loading")}</div>;
	if (isError) return <div>{t("paths:progressBanner.error")}</div>;

	return (
		<div className={style.banner}>
			<div className={style.pathContent}>
				<div className={style.header}>
					<div>
						<h2>{t("paths:progressBanner.title")}</h2>
					</div>
					<div className={style.buttonHolder}>
						<PathScheduleAppointment />
					</div>
				</div>
				<div className={style.body}>
					<PathProgressBar currentCourse={11} coursesInPath={14} />
				</div>
			</div>
			<div className={style.coursesContent}>
				<PathCoursesProgressHolder courses={courses} />
			</div>
		</div>
	);
}

export default PathProgressBanner;
